// removed by extract-text-webpack-plugin
module.exports = {"modalContainer":"_3piymI3jcI8WJFqKX9nxpy","open":"_3UHaAN9jZDAOP6MS8KOjHQ","window":"_3ytZJhr8xvOrs7bgSdJGfc","content":"_2A2DiYilvicTV32yTATu5o","question":"_2ptbwhEki8DwzPso7hpjoe","buttons":"_3O4r2NnP_CPQKzI_-jZXyq"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ConfirmationModal/style.css
// module id = 287
// module chunks = 0